import { FieldValues } from "react-hook-form";

import Button, { ButtonTypes } from "../../../../components/Button";
import {
  Field,
  FieldHelper,
  FieldLabel,
} from "../../../../components/FormPanel";
import { SelectForm } from "../../../../components/Input";
import { listingOptionOf } from "./constants";
import { EditorError, FindAction } from "./styles";
import { ListingPickerProps } from "./types";

export const ListingPicker = <T extends FieldValues>({
  control,
  disabled,
  candidates,
  noMatchMessage,
  discoveryError,
  isFinding,
  onFind,
}: ListingPickerProps<T>) => {
  const candidateOptions = candidates.map(listingOptionOf);

  return (
    <>
      <FindAction>
        <Button
          type={ButtonTypes.secondary}
          size="small"
          disabled={disabled}
          isLoading={isFinding}
          onClick={onFind}
        >
          Find listings
        </Button>
      </FindAction>
      {noMatchMessage && (
        <FieldHelper role="status">{noMatchMessage}</FieldHelper>
      )}
      {discoveryError && (
        <EditorError role="alert">{discoveryError}</EditorError>
      )}
      {candidates.length > 0 && (
        <Field>
          <FieldLabel htmlFor="instrument-editor-listing">Listing</FieldLabel>
          <SelectForm
            id="instrument-editor-listing"
            name="listing"
            control={control}
            options={candidateOptions}
            menuPlacement="auto"
            rules={{ required: "Choose a listing" }}
            disabled={disabled}
          />
        </Field>
      )}
    </>
  );
};
